import React, { useMemo, useState } from 'react';
import './Canales.css';

export default function Canales(props) {
  const [phonePopup, setPhonePopup] = useState(null);
  const isDesktop = useMemo(() => {
    if (typeof window === "undefined" || !window.matchMedia) {
      return false;
    }
    return window.matchMedia("(min-width: 900px)").matches;
  }, []);
  const channels = [
    {
      id: 1,
      title: "CAE",
      description: "Solicitud de cobros y validación de pedidos\nAltas y reactivaciones de Presentadores\nFacturación de pedidos\nOrden de Servicio Técnico y Devoluciones\nAclaración de compensaciones y/o promociones",
      buttons: [
        { label: "Visitar sitio", url: "https://thermomixusa.atlassian.net/servicedesk/customer/portal/36" },
        { label: "Enviar mail", email: "cae@thermomix.mx" }
      ],
      colorClass: "green",
      color: "#1aa34a"
    },
    {
      id: 2,
      title: "Help Desk",
      description: "Apoyo para concluir el proceso de Pedidos Digitales\nAsesoría con algún impedimento para concluir el proceso de Pre registro de Presentadores.\nLos horarios de recepción de incidencias son de 9 a 6 pm, de lunes a viernes.",
      buttons: [
        { label: "Enviar mail", email: "help-desk@thermomix.mx" }
      ],
      colorClass: "orange",
      color: "#f39c12"
    },
    {
      id: 3,
      title: "Servicio a Clientes",
      description: "Sugerir correcciones a recetas de Cookidoo®\nResolver dificultades de conexión a Cookidoo®\nMi cliente debe contactar personalmente si necesita:\nSolicitar una recolección para Servicio Técnico\nDar seguimiento a su orden de servicio técnico",
      buttons: [
        { label: "Llamar", phone: "8002001121" },
        { label: "WhatsApp", url: "https://wa.me/5541693997" }
      ],
      colorClass: "red",
      color: "#e63946"
    },
    {
      id: 4,
      title: "SHOP",
      description: "Iniciar sesión en mi cuenta de presentador\nIngresar y consultar pedidos\nAdquirir accesorios o artículos Thermomix®\nVisitar la página oficial de TM7",
      buttons: [
        { label: "Visitar sitio", url: "https://shop.thermomix.mx/" }
      ],
      colorClass: "purple",
      color: "#7e57c2"
    },
    {
      id: 5,
      title: "Centro de ayuda",
      description: "Resolver preguntas frecuentes como:\n¿Cuál es el consumo de energía de TM7?\n¿Pueden usarse varios Thermomix® Sensor al mismo tiempo?\n¿De qué material está hecho el Cortador Thermomix®?",
      buttons: [
        { label: "Visitar sitio", url: "https://servicio.thermomix.mx/hc/es-419" }
      ],
      colorClass: "yellow",
      color: "#f1c40f"
    },
    {
      id: 6,
      title: "Digital Credit",
      description: "Confirmar la liquidación de mi financiamiento\nAdelantar pagos de mi financiamiento o liquidar\nSolicitar un Estado de Cuenta\nMi cliente debe contactar personalmente si necesita:\nAdelantar pagos, liquidar o solicitar un Estado de Cuenta",
      buttons: [
        { label: "Llamar", phone: "5562686098" },
        { label: "Llamar", phone: "5562686099" }
      ],
      colorClass: "blue",
      color: "#1f7db8"
    },
    {
      id: 7,
      title: "Digital Credit",
      description: "Conocer los montos de mi mensualidad\nVerificar el estado de cuenta de mi financiamiento\nSaber las fechas de mis pagos\nEs necesario acceder con los datos de tu RFC, tu número de propuesta y tu celular",
      buttons: [
        { label: "Visitar sitio", url: "https://mivorwerk.digitalcredit.mx" }
      ],
      colorClass: "lightblue",
      color: "#2d8ac7"
    },
    {
      id: 8,
      title: "Pines Digital Credit",
      description: "Solicitar un estatus de propuesta,\nResolver temas con los pines\nAlguna situación relacionada con las propuestas de mis clientes.\nLun-Dom de 9 a.m. a 6 p.m. No aplican en días festivos.",
      buttons: [
        { label: "Llamar", phone: "6149800610" }
      ],
      colorClass: "blue",
      color: "#1f7db8"
    }
  ];

  const ChannelCard = ({ channel }) => (
    <div style={{
      backgroundColor: "#ffffff",
      borderRadius: "0",
      borderBottomRightRadius: "50px",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      minHeight: "200px",
      boxShadow: "0 0 0 4px #ffffff inset",
      border: `4px solid ${channel.color}`
    }}>
      <div style={{
        padding: "18px 22px 10px 22px"
      }}>
        <h3 style={{
          margin: "0 0 10px 0",
          fontSize: "22px",
          fontWeight: "700",
          color: channel.color
        }}>
          {channel.title}
        </h3>
        <p style={{
          margin: "3px 0",
          fontSize: "14px",
          lineHeight: "1.3em",
          fontWeight: "600",
          color: "#333",
          whiteSpace: "pre-line"
        }}>
          {channel.description}
        </p>
      </div>
      <div style={{
        display: "flex",
        flexWrap: "wrap"
      }}>
        {channel.buttons.map((btn, idx) => {
          const href = btn.url 
            ? btn.url 
            : btn.email 
              ? `mailto:${btn.email}` 
              : btn.phone 
                ? `tel:${btn.phone}` 
                : "#";
          const isExternal = btn.url !== undefined;
          const isPhone = btn.phone !== undefined;
          const handleClick = (event) => {
            if (isPhone && isDesktop) {
              event.preventDefault();
              setPhonePopup(btn.phone);
            }
          };
          
          return (
            <a
              key={idx}
              href={href}
              target={isExternal ? "_blank" : undefined}
              rel={isExternal ? "noopener noreferrer" : undefined}
              onClick={handleClick}
              style={{
                flex: "1 1 160px",
                padding: "14px 0",
                textAlign: "center",
                fontWeight: "700",
                fontSize: "16px",
                color: "#ffffff",
                textDecoration: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                backgroundColor: channel.color,
                borderLeft: idx > 0 ? "2px solid rgba(255,255,255,0.4)" : "none"
              }}
            >
              {btn.label === "Enviar mail" && (
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  width="28" 
                  height="28" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                >
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
              )}
              {btn.label === "Llamar" && (
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  width="28" 
                  height="28" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                >
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
              )}
              {btn.label === "Visitar sitio" && (
                <img
                  src="/assets/img/icons/external_white_26_fat.png"
                  alt=""
                  style={{ width: "26px", height: "26px" }}
                />
              )}
              {btn.label === "WhatsApp" && (
                <img
                  src="/assets/img/icons/whatsapp_white_26.png"
                  alt=""
                  style={{ width: "26px", height: "26px" }}
                />
              )}
              {btn.label}
            </a>
          );
        })}
      </div>
    </div>
  );

  return (
    <div style={{
      backgroundColor: "#ffffff",
      margin: 0,
    }}>
      <div
        className="canales-grid"
        style={{
          maxWidth: "1100px",
          width: "100%",
          margin: "30px auto",
          padding: "0 16px",
          boxSizing: "border-box",
          display: "grid",
          gap: "20px"
        }}
      >
        {channels.map((channel) => (
          <ChannelCard key={channel.id} channel={channel} />
        ))}
      </div>
      {phonePopup && (
        <div
          role="dialog"
          aria-modal="true"
          aria-label="Número telefónico"
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            padding: "16px"
          }}
          onClick={() => setPhonePopup(null)}
        >
          <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "12px",
              padding: "22px 24px",
              minWidth: "280px",
              maxWidth: "90vw",
              boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
              display: "flex",
              flexDirection: "column",
              gap: "12px"
            }}
            onClick={(event) => event.stopPropagation()}
          >
            <div style={{
              fontSize: "18px",
              fontWeight: "700",
              color: "#333"
            }}>
              Número telefónico
            </div>
            <div style={{
              fontSize: "22px",
              fontWeight: "800",
              color: "#1f7db8",
              letterSpacing: "0.5px"
            }}>
              {phonePopup}
            </div>
            <button
              type="button"
              onClick={() => setPhonePopup(null)}
              style={{
                alignSelf: "flex-end",
                backgroundColor: "#009a3d",
                color: "#ffffff",
                border: "none",
                borderRadius: "8px",
                padding: "10px 16px",
                fontWeight: "700",
                cursor: "pointer"
              }}
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
